import React from "react";
import {RouteComponentProps} from "@reach/router";

interface Props extends RouteComponentProps {
  children: any;
}

export default function Rooter(props: Props) {
  return props.children
}